import ChecklistComponent, {
  ChecklistReportComponentProps,
} from './ChecklistReportComponent';

export default ChecklistComponent;

export type { ChecklistReportComponentProps };
